import _ from 'lodash';
import update from 'immutability-helper';
import {Channels} from 'cl-api';
const SET_EBAY_ACCOUNTS = 'accountPage/eBayAccounts/SET_EBAY_ACCOUNTS';
const REMOVE_EBAY_ACCOUNT = 'accountPage/eBayAccounts/REMOVE_EBAY_ACCOUNT';
const SET_SELECTED_TEMPLATE_TAG_SET_ID = 'accountPage/integrations/SET_SELECTED_TEMPLATE_TAG_SET_ID';
const SET_INVOICES = 'accountPage/billingHistory/SET_INVOICES';
const SET_CROSS_SELL_GALLERY_ITEMS_IDS = 'accountPage/eBayAccounts/SET_CROSS_SELL_GALLERY_ITEMS_IDS';
const UPDATE_AMAZON_ACCOUNT_NAME = 'accountPage/amazonAccounts/UPDATE_AMAZON_ACCOUNT_NAME';
const UPDATE_CHANNEL_ACCOUNT_QUANTITY_SYNC = 'accountPage/eBayAccounts/UPDATE_CHANNEL_ACCOUNT_QUANTITY_SYNC';
const CLEAR_ADD_AMAZON_ACCOUNT_ERROR = 'accountPage/amazonAccounts/CLEAR_ADD_AMAZON_ACCOUNT_ERROR';

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case SET_SELECTED_TEMPLATE_TAG_SET_ID:
      return {
        ...state,
        selectedTemplateTagSetId: action.id,
      };
    case SET_EBAY_ACCOUNTS:
      let {accounts} = action;
      accounts = _.keyBy(accounts, 'UserID');
      return {
        ...state,
        accounts: accounts,
      };
    case REMOVE_EBAY_ACCOUNT:
      return {
        ...state,
        accounts: _.omit(state.accounts, action.UserID),
      };
    case SET_INVOICES:
      return {
        ...state,
        invoices: action.invoices,
      };
    case SET_CROSS_SELL_GALLERY_ITEMS_IDS:
      const {sellerId, globalId, ids} = action;
      let updatedAccount = {};
      if (_.get(state.accounts, `${sellerId}.crossSellItemsData`)) {
        updatedAccount = {
          ...state.accounts[sellerId],
          crossSellItemsData: {
            [globalId]: ids,
            ...state.accounts[sellerId].crossSellItemsData,
          },
        };
      } else {
        updatedAccount = {
          crossSellItemsData: {
            [globalId]: ids,
          },
          ...state.accounts[sellerId],
        };
      }
      return update(state, {
        accounts: {
          [sellerId]: {
            $set: updatedAccount,
          },
        },
      });
    case UPDATE_AMAZON_ACCOUNT_NAME:
      return update(state, {
        amazonAccounts: {
          [action.amazonSellerId]: {
            name: {$set: action.amazonAccountName},
          },
        },
      });
    case CLEAR_ADD_AMAZON_ACCOUNT_ERROR:
      return update(state, {
        lastAmazonError: {$set: null},
      });
    case UPDATE_CHANNEL_ACCOUNT_QUANTITY_SYNC:
      const toUpdate = {
        [action.sellerId]: {
          quantitySyncEnabled: {$set: action.quantitySyncEnabled},
        },
      };
      let accountsKey;
      switch (action.channel) {
        case Channels.Amazon:
          accountsKey = 'amazonAccounts';
          break;
        case Channels.EBay:
          accountsKey = 'accounts';
          break;
        default:
          return state;
      }
      return update(state, {
        [accountsKey]: toUpdate,
      });
    default:
      return state;
  }
}

export function setEBayAccounts(accounts) {
  return {type: SET_EBAY_ACCOUNTS, accounts};
}

export function removeEBayAccount(UserID) {
  return {type: REMOVE_EBAY_ACCOUNT, UserID};
}

export function setSelectedTemplateTagSetId(id) {
  return {type: SET_SELECTED_TEMPLATE_TAG_SET_ID, id};
}

export function setInvoices(invoices) {
  return {type: SET_INVOICES, invoices};
}

export function setCrossSellGalleryItemsIds(sellerId, globalId, ids) {
  return {type: SET_CROSS_SELL_GALLERY_ITEMS_IDS, sellerId, globalId, ids};
}

export function updateAmazonAccountName(amazonSellerId, amazonAccountName) {
  return {type: UPDATE_AMAZON_ACCOUNT_NAME, amazonSellerId, amazonAccountName};
}

export function clearAddAmazonAccountError() {
  return {type: CLEAR_ADD_AMAZON_ACCOUNT_ERROR};
}

export function updateChannelAccountQuantitySync(sellerId, quantitySyncEnabled, channel) {
  return {type: UPDATE_CHANNEL_ACCOUNT_QUANTITY_SYNC, sellerId, quantitySyncEnabled, channel};
}
